import React from "react";
import HeaderOne from "../common/header/HeaderOne";
import FooterOne from "../common/footer/FooterOne";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Technology from "../component/Technologies/Technology.js";
import SideStickButton from "./SideStickButton";
import GoogleTagManager from "./GTM";
import SideStickMenu from "./SideStickMenu.js";

const AccordionItem = ({ eventKey, header, body }) => {
  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>
        {<div className="color1">{header}</div>}
      </Accordion.Header>
      <Accordion.Body>{body}</Accordion.Body>
    </Accordion.Item>
  );
};

const React1 = () => {
  <GoogleTagManager gtmId="GTM-WV4R3LC" />;
  return (
    <>
      <div>
        <Helmet>
          <title>React-js-development-services | Origin software</title>
          <link rel="canonical" href="./React-js-development-services" />
          <meta
            name="description"
            content="Get top-quality React JS development services from our team of experienced developers. Contact us to bring your vision to life."
          />
          <meta name="keywords" content="React js development services" />
        </Helmet>
        <main className="main-wrapper">
          <HeaderOne />
          <SideStickButton />
          <div className="section-padding-equal">
            <div className="container">
              <div className="row row-40">
                <div className="col-lg-3 why-choose-us">
                  <div className="sidebar-fixed">
                    <SideStickMenu />
                  </div>
                </div>
                <div className="title-BC col-lg-9">
                  <h1 className="color">React JS Development Services</h1>
                  <img
                    className="img mb--20"
                    src="../images/Slider/React.png"
                    alt="React-js-development-services"
                  />
                  <p className="mb--20">
                    React is a popular JavaScript library for building user
                    interfaces. Our team of experienced React developers
                    provides top-notch React JS development services to help
                    businesses create dynamic, interactive, and high-performance
                    web applications. Whether you need to build a new web
                    application from scratch or revamp your existing one, our
                    React development team can help.{" "}
                  </p>

                  <h4 className="mb--20">
                    Our React JS Development Services Include the:
                  </h4>
                  <p>
                    <ul className="b">
                      <li>React JS Web Development</li>
                      <li>React Native App Development</li>
                      <li>React UI/UX Design</li>
                      <li>React Maintenance & Support</li>
                      <li>React Migration Services</li>
                      <Link
                        to={process.env.PUBLIC_URL + "/contact"}
                        className="axil-btn btn-fill-primary btn-small"
                      >
                        Contact Us
                      </Link>
                    </ul>
                  </p>

                  <div>
                    <h4>Our Core Technology</h4>
                    <Technology />
                  </div>

                  <Accordion>
                    <h4 className="color">React.Js FAQ's</h4>
                    <AccordionItem
                      eventKey="1"
                      header="Why Choose Us for React JS Development Services?"
                      body={
                        <>
                          <ul>
                            <h6 className="mb--20">Experienced Developers:</h6>
                            ► Our developers have extensive experience in
                            developing web applications using React. They are
                            well-versed in the latest React js development
                            practices and technologies.
                            <br />
                            <br />
                            <h6 className="mb--20">Quality Code:</h6>► We write
                            clean, maintainable code that follows best coding
                            practices and meets industry standards. <br />
                            <br />
                            <h6 className="mb--20">Fast Delivery:</h6>
                            ► We are committed to delivering projects on time,
                            within budget, and to a high-quality standard.
                            <br />
                            <br />
                            <h6 className="mb--20">24/7 Support:</h6>
                            ► Our developers are available 24/7 to provide
                            technical support and maintenance services to ensure
                            your web application runs smoothly.
                            <br />
                            <br />
                            <h6 className="mb--20">Affordable Pricing:</h6>► Our
                            React js development services are affordable, and we
                            offer flexible pricing options to meet your specific
                            requirements and budget.
                          </ul>
                        </>
                      }
                    />
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
          <FooterOne />
        </main>
      </div>
    </>
  );
};

export default React1;
// 126
